import {remCalc} from '_themeUtils'

const resetPasswordDrawer = {
    ResetPasswordDrawer: {
        baseStyle: () => ({
            resetPasswordBox: {
                paddingBottom: 'spacing.14',
                borderBottom: '1px solid',
                borderColor: 'color.border.grey.300',
            },
            resetPasswordtitle: {
                marginBottom: 'spacing.7',
            },
            title: {
                textStyle: 'paragraphMd',
                fontWeight: 400,
            },
            confirmButton: {
                width: '50%',
                marginLeft: 'auto',
            },
            resetPasswordSuccessBox: {
                gap: remCalc(16),
            }, 
            succesTitle: {
                textStyle: 'displayXs',
                fontWeight: 500,
                textAlign: 'center',
                letterSpacing: remCalc(1),
                lineHeight: 1.5,
            },
            succesmessage: {
                textStyle: 'paragraphMd',
                fontWeight: 400,
                letterSpacing: remCalc(0.6),
                lineHeight: 1.5,
            },
            registrationBox: {
                paddingTop: 'spacing.14',
            },
            registrationTitle: {
                textStyle: 'paragraphMd',
                fontWeight: 400,
                letterSpacing: remCalc(4),
                textTransform: 'uppercase',
            },
            registrationText: {
                textStyle: 'paragraphMd',
                fontWeight: 300,
                letterSpacing: remCalc(0.6),
                paddingTop: 'spacing.4',
                paddingBottom: 'spacing.8',
            },
        }),
    },
}

export default resetPasswordDrawer
